import React from 'react';
import { TextField, MenuItem, TextFieldProps } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { ReasonCodes } from 'types/ReasonCodes';

type Props = {
  reasonCodes: ReasonCodes[];
};

const ReasonCodesInput: React.FC<Props & TextFieldProps> = ({
  reasonCodes,
  ...rest
}) => {
  const { t } = useTranslation('return');
  return (
    <TextField
      fullWidth
      label={t('headings.reason')}
      variant="outlined"
      select
      {...rest}
    >
      <MenuItem value={0}>{t('options.default')}</MenuItem>
      {reasonCodes.map(({ name, reasonID }) => (
        <MenuItem key={reasonID} value={reasonID}>
          {name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default ReasonCodesInput;
